import { render } from "./WardCheckin.vue?vue&type=template&id=25c7e73a"
import script from "./WardCheckin.vue?vue&type=script&lang=js"
export * from "./WardCheckin.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__